<template>
  <div :class="$style.errors">
    <div class="pt-4 pb-4 d-flex align-items-end mt-auto">
      <img src="resources/images/logo-farmatodo-azul.svg" alt="Logo Farmatodo" />

    </div>
    <div class="pl-5 pr-5 pt-5 pb-5 mb-auto text-dark font-size-30 text-center" :class="$style.container">
      <div class="font-weight-bold mb-3">Página no encontrada</div>
      <div>Esta página ya no se encuentra disponible o no ha sido creada</div>
      <div class="font-weight-bold font-size-70 mb-1">404</div>
      <router-link to="/" class="btn btn-outline-primary width-100">Regresar</router-link>
    </div>
    <div class="mt-auto pb-5 pt-5">

      <div class="text-gray-4 text-center">© 2019 Farmatodo. Todos los derechos reservados.</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AirError404',
}
</script>
<style lang="scss" module>
@import "@/components/system/Errors/style.module.scss";
</style>
